var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { copyDetails } from '../CfCourseCardUtil';
var CopyDetailsButton = function (_a) {
    var userDetails = _a.userDetails, courseData = _a.courseData, studentName = _a.studentName, onCopySuccess = _a.onCopySuccess;
    var _b = __read(useState(false), 2), isActive = _b[0], setIsActive = _b[1];
    return (React.createElement(Button, { size: "small", onClick: function () {
            copyDetails(setIsActive, userDetails, courseData, studentName, onCopySuccess);
        }, startIcon: React.createElement("i", { className: "fi fi-rr-clone text-sm" }), variant: "text", className: "whitespace-nowrap lfc-text-[#17154D] ".concat(isActive ? 'lfc-text-success-500' : '', " transition-colors") }, isActive ? 'Details Copied' : 'Copy Details'));
};
export default CopyDetailsButton;
//# sourceMappingURL=CopyDetailsButton.js.map